// https://github.com/mattdiamond/Recorderjs/blob/master/src/recorder.js

export default function Exporter(audioBuffer) {
  this.buffer = audioBuffer;

  this.export = function(type) {
    const buffers = [];

    for (let c = 0; c < audioBuffer.numberOfChannels; c++) {
      buffers.push(
        mergeBuffers([audioBuffer.getChannelData(c)], audioBuffer.length)
      );
    }

    let interleaved;
    if (audioBuffer.numberOfChannels === 2) {
      interleaved = interleave(buffers[0], buffers[1]);
    } else {
      interleaved = buffers[0];
    }

    const wav = encodeWav(
      interleaved,
      audioBuffer.numberOfChannels,
      audioBuffer.sampleRate
    );

    const blob = new Blob([wav], { type });

    return blob;
  };

  function mergeBuffers(buffers, length) {
    const result = new Float32Array(length);
    let offset = 0;

    for (let i = 0; i < buffers.length; i++) {
      result.set(buffers[i], offset);
      offset = offset + buffers[i].length;
    }

    return result;
  }

  function interleave(inputL, inputR) {
    const length = inputL.length + inputR.length;
    const result = new Float32Array(length);

    let index = 0;

    let inputIndex = 0;

    while (index < length) {
      result[index++] = inputL[inputIndex];
      result[index++] = inputR[inputIndex];
      inputIndex++;
    }
    return result;
  }

  function writeString(view, offset, string) {
    for (let i = 0; i < string.length; i++) {
      view.setUint8(offset + i, string.charCodeAt(i));
    }
  }

  function floatTo16BitPCM(output, offset, input) {
    for (let i = 0; i < input.length; i++, offset = offset + 2) {
      const s = Math.max(-1, Math.min(1, input[i]));
      output.setInt16(offset, s < 0 ? s * 0x8000 : s * 0x7fff, true);
    }
  }

  function encodeWav(samples, numChannels, sampleRate) {
    const buffer = new ArrayBuffer(44 + samples.length * 2);
    const view = new DataView(buffer);

    /* RIFF identifier */
    writeString(view, 0, 'RIFF');
    /* RIFF chunk length */
    view.setUint32(4, 36 + samples.length * 2, true);
    /* RIFF type */
    writeString(view, 8, 'WAVE');
    /* format chunk identifier */
    writeString(view, 12, 'fmt ');
    /* format chunk length */
    view.setUint32(16, 16, true);
    /* sample format (raw) */
    view.setUint16(20, 1, true);
    /* channel count */
    view.setUint16(22, numChannels, true);
    /* sample rate */
    view.setUint32(24, sampleRate, true);
    /* byte rate (sample rate * block align) */
    view.setUint32(28, sampleRate * 4, true);
    /* block align (channel count * bytes per sample) */
    view.setUint16(32, numChannels * 2, true);
    /* bits per sample */
    view.setUint16(34, 16, true);
    /* data chunk identifier */
    writeString(view, 36, 'data');
    /* data chunk length */
    view.setUint32(40, samples.length * 2, true);

    floatTo16BitPCM(view, 44, samples);

    return view;
  }
}
